// extracted by mini-css-extract-plugin
export default {"special_icon_wrapper":"HeaderProfile_special_icon_wrapper__THXoX"};